import { connect } from 'react-redux';
import { IState } from '../../store';
import { closeSimilarSuccess } from '../../store/deal-rent';
import { DealRentSimilarSuccessModal } from './DealRentSimilarSuccessModal';

export function mapStateToProps(state: IState) {
  return {
    isOpen: state.dealRent.isSimilarSuccessModal,
  };
}

export const DealRentSimilarSuccessModalContainer = connect(mapStateToProps, { closeModal: closeSimilarSuccess })(
  DealRentSimilarSuccessModal,
);
